export default __webpack_public_path__ + "static/media/allocation.056213c2.png";